'use client'

import React, { useRef } from 'react'

import { Scrollbar, useDragScroll, useScrollProgress } from '@/components/ui/horizontal-scroll'

type Props = {
  label: string
  children: React.ReactNode
}

/**
 * Takes the table as children so it stays server-rendered - a cookie inventory is 146 rows.
 * role/aria-label/tabIndex must sit on the scrolling element or the region is not keyboard-scrollable.
 */
export const LegalTableScroll: React.FC<Props> = ({ label, children }) => {
  const scrollRef = useRef<HTMLDivElement>(null)

  useDragScroll(scrollRef)
  const { scrollProgress, isVisible } = useScrollProgress(scrollRef)

  return (
    <>
      <div
        ref={scrollRef}
        className="w-full overflow-x-auto scrollbar-hide"
        role="region"
        aria-label={label}
        tabIndex={0}
      >
        {children}
      </div>
      <Scrollbar scrollProgress={scrollProgress} isVisible={isVisible} className="mt-4" />
    </>
  )
}
